export const getRegistroSezionaleChannelLabel = (channel) => {
    const labels = {
        b2c: 'Privati (B2C)',
        b2b: 'Aziende (B2B)',
        b2g: 'Enti pubblici (B2G)',
    };
    return labels[channel] || channel;
};

export const getNextRegistroNumber = (registro) => {
    if (!registro) return null;
    const next = (registro.currentNumber || 0) + 1;
    const padded = String(next).padStart(registro.padDigits || 3, '0');
    const year = registro.yearSuffix ? `/${registro.fiscalYear || new Date().getFullYear()}` : '';
    return `${registro.prefix}-${padded}${year}`;
};

export const formatRegistroNumber = (registro, number) => {
    if (!registro || !number) return null;
    const padded = String(number).padStart(registro.padDigits || 3, '0');
    const year = registro.yearSuffix ? `/${registro.fiscalYear || new Date().getFullYear()}` : '';
    return `${registro.prefix}-${padded}${year}`;
};

export const getB2bInvoiceStatusLabel = (status) => {
    const labels = {
        bozza: 'Bozza',
        emessa: 'Emessa',
        consegnata: 'Consegnata',
        pagata: 'Pagata',
        scaduta: 'Scaduta',
        annullata: 'Annullata',
    };
    return labels[status] || status;
};

export const getB2bInvoiceStatusColor = (status) => {
    const colors = {
        bozza: 'default',
        emessa: 'processing',
        consegnata: 'blue',
        pagata: 'success',
        scaduta: 'error',
        annullata: 'error',
    };
    return colors[status] || 'default';
};

export const getSdiStatusLabel = (sdiStatus) => {
    const labels = {
        in_elaborazione: 'SDI in elaborazione',
        consegnata: 'SDI consegnata',
        rifiutata: 'SDI rifiutata',
        mancata_consegna: 'Mancata consegna',
    };
    return sdiStatus ? (labels[sdiStatus] || sdiStatus) : 'Non trasmessa';
};

export const getSdiStatusColor = (sdiStatus) => {
    const colors = {
        in_elaborazione: 'processing',
        consegnata: 'success',
        rifiutata: 'error',
        mancata_consegna: 'warning',
    };
    return sdiStatus ? (colors[sdiStatus] || 'default') : 'default';
};

export const getPaymentTermsLabel = (terms) => {
    const labels = {
        immediato: 'Pagamento immediato',
        net15: 'Net 15 giorni',
        net30: 'Net 30 giorni',
        net60: 'Net 60 giorni',
        net90: 'Net 90 giorni',
        rateizzazione: 'Rateizzazione',
    };
    return labels[terms] || terms;
};

export const getBillingChannelLabel = (channel) => {
    const labels = {
        b2c: 'Privati (B2C)',
        b2b: 'Aziende (B2B)',
        b2g: 'Enti pubblici (B2G)',
    };
    return labels[channel] || channel;
};

export const validatePreSdiB2bInvoice = (invoice) => {
    const issues = [];
    if (!invoice) return issues;

    if (!(invoice.recipient?.businessName || '').trim()) {
        issues.push({
            id: 'recipient_name',
            level: 'error',
            message: 'Ragione sociale del destinatario mancante: la fattura non può essere trasmessa senza un nome azienda.',
        });
    }

    const vatNum = (invoice.recipient?.vatNumber || '').replace(/\s/g, '');
    if (!vatNum) {
        issues.push({
            id: 'vat_number_missing',
            level: 'error',
            message: 'Partita IVA del destinatario mancante: è obbligatoria per la fatturazione elettronica B2B.',
        });
    } else if (!/^\d{11}$/.test(vatNum)) {
        issues.push({
            id: 'vat_number_invalid',
            level: 'error',
            message: `Partita IVA "${vatNum}" non valida: deve essere composta esattamente da 11 cifre numeriche.`,
        });
    }

    const hasSdiCode = (invoice.recipient?.sdiCode || '').trim().length > 0;
    const hasPec = (invoice.recipient?.pec || '').trim().length > 0;
    if (!hasSdiCode && !hasPec) {
        issues.push({
            id: 'sdi_recapito',
            level: 'error',
            message: 'Recapito SDI mancante: indicare il codice destinatario SDI (7 caratteri) oppure la PEC del destinatario.',
        });
    }

    if (!(invoice.recipient?.address || '').trim()) {
        issues.push({
            id: 'address',
            level: 'warning',
            message: 'Indirizzo del destinatario non indicato: il campo è atteso dallo SDI per la corretta consegna.',
        });
    }

    const lines = invoice.lines || [];
    if (lines.length === 0) {
        issues.push({
            id: 'no_lines',
            level: 'error',
            message: 'La fattura non contiene righe di dettaglio: aggiungere almeno un articolo o servizio.',
        });
    } else {
        const emptyDescCount = lines.filter((l) => !(l.description || '').trim()).length;
        if (emptyDescCount > 0) {
            issues.push({
                id: 'empty_descriptions',
                level: 'warning',
                message: `${emptyDescCount === 1 ? '1 riga' : `${emptyDescCount} righe`} senza descrizione: inserire il dettaglio del bene o servizio fornito.`,
            });
        }

        const zeroPriceCount = lines.filter((l) => !(Number(l.unitPrice) > 0)).length;
        if (zeroPriceCount > 0) {
            issues.push({
                id: 'zero_price_lines',
                level: 'warning',
                message: `${zeroPriceCount === 1 ? '1 riga' : `${zeroPriceCount} righe`} con prezzo unitario a zero: verificare gli importi prima dell'invio.`,
            });
        }
    }

    if (!(Number(invoice.totalAmount) > 0)) {
        issues.push({
            id: 'zero_total',
            level: 'error',
            message: 'Importo totale della fattura è zero o non valido: la fattura non può essere trasmessa allo SDI.',
        });
    }

    if (!invoice.dueDate) {
        issues.push({
            id: 'due_date',
            level: 'warning',
            message: 'Scadenza di pagamento non indicata: specificare i termini per una corretta gestione del credito.',
        });
    }

    return issues;
};

export const getFreeInvoiceStatusLabel = (status) => {
    const labels = {
        bozza: 'Bozza',
        emessa: 'Emessa',
        annullata: 'Annullata',
    };
    return labels[status] || status;
};

export const getFreeInvoiceStatusColor = (status) => {
    const colors = {
        bozza: 'default',
        emessa: 'processing',
        annullata: 'error',
    };
    return colors[status] || 'default';
};

export const getFreeInvoiceReconciliationStatusLabel = (reconciliationStatus) => {
    const labels = {
        da_riconciliare: 'Da riconciliare',
        riconciliata: 'Riconciliata',
    };
    return reconciliationStatus ? (labels[reconciliationStatus] || reconciliationStatus) : '–';
};

export const getFreeInvoiceReconciliationStatusColor = (reconciliationStatus) => {
    const colors = {
        da_riconciliare: 'warning',
        riconciliata: 'success',
    };
    return reconciliationStatus ? (colors[reconciliationStatus] || 'default') : 'default';
};

export const getFreeInvoiceLinkedTypeLabel = (linkedType) => {
    const labels = {
        matricola: 'Matricola',
        carico: 'Carico (DDT)',
        pratica: 'Pratica',
    };
    return labels[linkedType] || linkedType;
};

export const getSalesDdtStatusLabel = (status) => {
    const labels = {
        bozza: 'Bozza',
        emesso: 'Emesso',
        fatturato: 'Fatturato',
        annullato: 'Annullato',
    };
    return labels[status] || status;
};

export const getSalesDdtStatusColor = (status) => {
    const colors = {
        bozza: 'default',
        emesso: 'processing',
        fatturato: 'success',
        annullato: 'error',
    };
    return colors[status] || 'default';
};

export const getInvoiceTypeLabel = (invoiceType) => {
    const labels = {
        immediata: 'Immediata',
        differita: 'Differita',
    };
    return invoiceType ? (labels[invoiceType] || invoiceType) : '–';
};

export const getInvoiceTypeColor = (invoiceType) => {
    const colors = {
        immediata: 'blue',
        differita: 'orange',
    };
    return invoiceType ? (colors[invoiceType] || 'default') : 'default';
};

export const recalculateBillingWorkspace = (workspace) => {
    if (!workspace) return workspace;

    const b2bInvoices = workspace.b2bInvoices || [];
    const freeInvoices = workspace.freeInvoices || [];
    const registriSezionali = workspace.registriSezionali || [];
    const activeDdts = workspace.activeDdts || [];

    const b2bSummary = {
        total: b2bInvoices.length,
        draft: b2bInvoices.filter((inv) => inv.status === 'bozza').length,
        emitted: b2bInvoices.filter((inv) => ['emessa', 'consegnata'].includes(inv.status)).length,
        paid: b2bInvoices.filter((inv) => inv.status === 'pagata').length,
        overdue: b2bInvoices.filter((inv) => inv.status === 'scaduta').length,
        totalEmitted: b2bInvoices
            .filter((inv) => ['emessa', 'consegnata', 'pagata'].includes(inv.status))
            .reduce((sum, inv) => sum + Number(inv.totalAmount || 0), 0),
        totalPaid: b2bInvoices
            .filter((inv) => inv.status === 'pagata')
            .reduce((sum, inv) => sum + Number(inv.totalAmount || 0), 0),
    };

    const registriSummary = {
        total: registriSezionali.length,
        active: registriSezionali.filter((r) => r.active).length,
        byChannel: {
            b2c: registriSezionali.filter((r) => r.channel === 'b2c').length,
            b2b: registriSezionali.filter((r) => r.channel === 'b2b').length,
            b2g: registriSezionali.filter((r) => r.channel === 'b2g').length,
        },
    };

    const freeInvoicesSummary = {
        total: freeInvoices.length,
        draft: freeInvoices.filter((inv) => inv.status === 'bozza').length,
        emitted: freeInvoices.filter((inv) => inv.status === 'emessa').length,
        daRiconciliare: freeInvoices.filter((inv) => inv.reconciliationStatus === 'da_riconciliare').length,
        riconciliate: freeInvoices.filter((inv) => inv.reconciliationStatus === 'riconciliata').length,
        totalEmitted: freeInvoices
            .filter((inv) => inv.status === 'emessa')
            .reduce((sum, inv) => sum + Number(inv.totalAmount || 0), 0),
    };

    const emessoDdts = activeDdts.filter((d) => d.status === 'emesso');
    const activeDdtsSummary = {
        total: activeDdts.length,
        draft: activeDdts.filter((d) => d.status === 'bozza').length,
        emitted: emessoDdts.length,
        fatturati: activeDdts.filter((d) => d.status === 'fatturato').length,
        pendingInvoice: emessoDdts.length,
        totalPendingAmount: emessoDdts.reduce((sum, d) => sum + Number(d.totalAmount || 0), 0),
    };

    return {
        ...workspace,
        summary: { b2bSummary, registriSummary, freeInvoicesSummary, activeDdtsSummary },
    };
};
